import {
  FETCH_COMMENTS,
  UPDATE_ADD_COMMENT_ERROR,
  UPDATE_ADD_REPLY_ERROR,
  UPDATE_ADD_REPLY_ID,
  UPDATE_ANON_USER_NAME,
  UPDATE_COMMENTS,
  UPDATE_COMMENTS_TIMESTAMP,
  UPDATE_COMMENTS_TIMESTAMP_FROZEN,
  UPDATE_EXPANDED_REPLY_IDS,
  UPDATE_FETCHING_COMMENTS_ERROR,
  UPDATE_IN_GUEST_FLOW,
  UPDATE_IN_GUEST_FLOW_REPLY,
  UPDATE_IS_FETCHING,
} from 'constants/actions';

export const fetchComments = () => {
  return { type: FETCH_COMMENTS };
};

export const updateAddReplyError = err => {
  return {
    type: UPDATE_ADD_REPLY_ERROR,
    err,
  };
};

export const updateAddCommentError = err => {
  return {
    type: UPDATE_ADD_COMMENT_ERROR,
    err,
  };
};

export const updateAddReplyId = addReplyId => {
  return { type: UPDATE_ADD_REPLY_ID, addReplyId };
};

export const updateAnonUserName = anonUserName => {
  return {
    type: UPDATE_ANON_USER_NAME,
    anonUserName,
  };
};

export const updateComments = comments => {
  return { type: UPDATE_COMMENTS, comments };
};

export const updateCommentsTimestamp = timestamp => {
  return { type: UPDATE_COMMENTS_TIMESTAMP, timestamp };
};

export const updateCommentsTimestampFrozen = frozen => {
  return { type: UPDATE_COMMENTS_TIMESTAMP_FROZEN, frozen };
};

export const updateExpandedReplyIds = expandedIds => {
  return { type: UPDATE_EXPANDED_REPLY_IDS, expandedIds };
};

export const updateFetchingCommentsError = fetchingError => {
  return { type: UPDATE_FETCHING_COMMENTS_ERROR, fetchingError };
};

export const updateInGuestFlow = inGuestFlow => {
  return { type: UPDATE_IN_GUEST_FLOW, inGuestFlow };
};

export const updateInGuestFlowReply = inGuestFlowReply => {
  return { type: UPDATE_IN_GUEST_FLOW_REPLY, inGuestFlowReply };
};

export const updateIsFetching = isFetching => {
  return { type: UPDATE_IS_FETCHING, isFetching };
};
